import React, { useEffect } from 'react';
import queryString from 'query-string';
import { Link } from 'react-router-dom';

import { AdjustTrackEvent } from 'modules/analytics/adjust';
import { trackEvent } from 'modules/analytics';
import {
  Wrapper,
  OverlayWrapper,
  Overlay,
  OverlayHeaderSection,
  OverlayContent,
  SwitchToAnchor,
} from 'components/ImportOnboarding/styles';
import {
  OverlayOverrideCSS,
  Header1,
  Paragraph,
} from 'components/LoginPage/styles';
import { useT } from 'client/i18n/hooks/useT';
import { SignupForm } from 'components/SignupForm';
import events from 'components/SignupPageContainer/events';
import { WordPressHero } from './components/WordPressHero';
import {
  Header2,
  SwitchToAnchorOverrideCSS,
  WordPressLogoContainer,
} from './styles';

function Hero({ isWordPressReferral, t }) {
  if (isWordPressReferral) {
    return (
      <WordPressLogoContainer>
        <WordPressHero />
      </WordPressLogoContainer>
    );
  }
  return (
    <SwitchToAnchor className={SwitchToAnchorOverrideCSS}>
      <Header2>
        {t(
          'SignupPage.Header',
          'Welcome to Anchor',
          'Anchor sign up page header'
        )}
      </Header2>
    </SwitchToAnchor>
  );
}

export function SignupPage({
  onSubmit,
  onClickRequestResetPassword,
  location: { search },
}) {
  const t = useT();
  const { ref } = queryString.parse(search);
  const isWordPressReferral = ref === 'wp';

  useEffect(() => {
    // Required for Floodlight tagging
    // eslint-disable-next-line no-undef
    gtag('event', 'conversion', {
      allow_custom_scripts: true,
      send_to: 'DC-9266237/ancho0/spoti00+standard',
    });

    // adjust log for viewing sign up
    trackEvent(
      null,
      { eventToken: AdjustTrackEvent.ONBOARDING_STARTED },
      // eslint-disable-next-line no-undef
      { providers: [Adjust] }
    );
  }, []);

  return (
    <Wrapper>
      <Hero isWordPressReferral={isWordPressReferral} t={t} />
      <OverlayWrapper>
        <Overlay className={OverlayOverrideCSS}>
          <OverlayHeaderSection>
            <Header1>
              {t(
                'SignupPage.CreateAccountHeader',
                'Create your account',
                'Anchor sign up page header'
              )}
            </Header1>
            {isWordPressReferral ? (
              <Paragraph>
                {t(
                  'SignupPage.WordPressReferralMessage',
                  'Record, share, and reach listeners everywhere.',
                  'Anchor sign up message'
                )}
              </Paragraph>
            ) : (
              <Paragraph>
                {t(
                  'SignupPage.LoginInsteadMessage',
                  'Already have an account? {loginLink} instead.',
                  'Log in instead of sign up message',
                  {
                    loginLink: (
                      <Link
                        key="sign-up-page__login-link"
                        data-cy="loginLink"
                        to="/login"
                        onClick={events.signUpSignInButtonClicked}
                      >
                        {t(
                          'SignupPage.LoginLinkText',
                          'Log in',
                          'Log in link text'
                        )}
                      </Link>
                    ),
                  }
                )}
              </Paragraph>
            )}
          </OverlayHeaderSection>
          <OverlayContent>
            <SignupForm
              onSubmit={onSubmit}
              onClickRequestResetPassword={onClickRequestResetPassword}
              isWordPressReferral={isWordPressReferral}
            />
          </OverlayContent>
        </Overlay>
      </OverlayWrapper>
    </Wrapper>
  );
}
